import React, { useState, useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { DropDown } from '../DropDown';
import { SettingsContext } from '../SettingsContext';
import { FhirClientContext } from '../FhirClientContext';

import './environment-selector.css';

const EnvironmentSelector = () => {
	let history = useHistory();
	let { formpath, environmentpath } = useParams();

	const settings = useContext(SettingsContext);
	const fhirClient = useContext(FhirClientContext);
	const [data, setData] = useState([]);
	const [environment, setEnvironment] = useState(settings.environmentDefault);
	const [formId, setFormId] = useState('');
	const [isLoadingFormList, setIsLoadingFormList] = useState(true);
	const appUrl = settings.fhirEndpoint + '/formio/formtemplates';

	const environmentValues = settings.environmentDropdown.split(',').map(env => {
		let arr = env.split('|');
		return { label: arr[0].trim(), value: arr[1].trim() };
	});

	useEffect(() => {
		setFormId(formpath ? formpath : '');
	}, [formpath]);

	useEffect(() => {
		if (appUrl) {
			const envValue = environmentpath ? environmentpath : settings.environmentDefault;
			setEnvironment(envValue ? envValue : settings.environmentDefault);
			const url = appUrl + '?category=publish&env=' + envValue;
			getForms(url);
		}
	}, [environmentpath, appUrl]);

	const getForms = (url) => {
		if (settings.features.enableNavigation &&
			(settings.features.enableAnonymousAccess === true || fhirClient.getAuthorizationHeader)) {
			const header = {
				method: 'get',
				headers: {
					'Ocp-Apim-Subscription-Key': settings.apiSubscriptionKey,
					'Authorization': fhirClient.getAuthorizationHeader ? fhirClient.getAuthorizationHeader() : ''
				}
			};

			fetch(url, header).then((response) => {
				return response.json();
			}).then((data) => {
				setData(data.map(item => ({ label: item.title, value: item._id })));
				setIsLoadingFormList(false);
			});
		}
	}

	const onSelectEnvironment = (event) => {
		const selectedValue = event.target.value;

		if (selectedValue) {
			const url = appUrl + '?category=publish&env=' + selectedValue;

			setFormId('');
			setEnvironment(selectedValue);
			setIsLoadingFormList(true);

			getForms(url);
		}
	}

	const onSelectForm = (event) => {
		const selectedValue = event.target.value;

		if (selectedValue) {
			setFormId(selectedValue);

			history.push(`/${environment}/form/${selectedValue}`);
		}
	}

	return (
		<div className="form-selector-group">
			<DropDown
				cssPrefix="environment-selector"
				labelText="Environment:"
				handleChange={onSelectEnvironment}
				value={environment}
				options={environmentValues}
			>
				{
					environmentValues.map((item, index) =>
						<option key={index} value={item.value}>{item.label}</option>
					)
				}
			</DropDown>

			<DropDown
				cssPrefix="form-selector"
				labelText="Form:"
				handleChange={onSelectForm}
				value={formId}
				isDisabled={isLoadingFormList}
				options={data}
			>
			</DropDown>
		</div>
	);
}

export default EnvironmentSelector;